import React from 'react'
import {
  FormControl, FormControlLabel, FormGroup, FormLabel,
  InputAdornment, Switch, TextField
} from '@mui/material'
import ColorSelector from '../../components/ColorSelector'

const SettingForm = ({ form, change }) => {
  const delayUnit = { endAdornment: <InputAdornment position="end">ms</InputAdornment> }

  return (
    <>
      <FormGroup className="form-group">
        <FormControl>
          <TextField variant="standard" label="ハンドル"
                     className="name"
                     inputProps={{ required: true, maxLength: 9 }}
                     value={form.name} onChange={change.value('name')} />
        </FormControl>
      </FormGroup>
      <FormGroup className="form-group mt-5">
        <FormControl>
          <TextField variant="standard" label="メモ"
                     className="memo" autoComplete="off"
                     inputProps={{ maxLength: 7 }}
                     value={form.memo} onChange={change.value('memo')} />
        </FormControl>
      </FormGroup>
      <FormGroup className="form-group mt-10">
        <FormControl>
          <FormControlLabel
            control={
              <Switch color="primary" className="chat-answer"
                      checked={form.chatAnswer}
                      onChange={change.checked('chatAnswer')} />
            }
            label="チャット解答マーク" />
        </FormControl>
      </FormGroup>
      <FormGroup className="form-group mt-10">
        <FormControl>
          <FormLabel>枠の色</FormLabel>
          <ColorSelector value={form.color}
                         onChange={change.direct('color')} />
        </FormControl>
      </FormGroup>
      <FormGroup className="form-group mt-15">
        <FormControl>
          <TextField type="number" variant="standard"
                     label="早押しボタンのディレイ" className="delay" sx={{ width: '140px' }}
                     inputProps={{ required: true, min: 0, max: 9900, step: 100 }}
                     InputProps={delayUnit}
                     value={form.delay} onChange={change.number('delay')} />
        </FormControl>
      </FormGroup>
    </>
  )
}

export default SettingForm
